export const featuredProductsGql = /* GraphQL */ `... on landingPageContent2023_featuredProducts_BlockType {
  typeHandle
  displayInHeaderQuicklinks
  id
  pageTitle
  featuredProducts {
    ... on product_productPage_Entry {
      uri
      relatedProductTitle
      relatedProductDescriptor
      relatedProductDescription
      relatedProductImage {
        ... on images_Asset {
          lpImageGridMasonry {
            srcWebp
            srcset
          }
        }
      }
    }
    ... on product_productPage2022_Entry {
      uri
      relatedProductTitle
      relatedProductDescriptor
      relatedProductDescription
      relatedProductImage {
        ... on images_Asset {
          lpImageGridMasonry {
            srcWebp
            srcset
          }
        }
      }
    }
    ... on landingPage_landingPage2023_Entry {
      uri
      relatedProductTitle
      relatedProductDescriptor
      relatedProductDescription
      relatedProductImage {
        ... on images_Asset {
          lpImageGridMasonry {
            srcWebp
            srcset
          }
        }
      }
    }
  }
}`;
